
import { Component, Vue, Watch } from 'vue-property-decorator';
import { store, StoreMutations } from '@/store';

@Component
export default class OpzioniOrdiniMTMComandi extends Vue {

    get toggleViewIcon(): string {
        return store.state.uiOrdiniMTM.listView ? 'mdi-apps' : 'mdi-format-list-bulleted';
    }

    private toggleView() {
        store.commit(StoreMutations.OrdiniMTMUiToggleListView);
    }

    private mostraOpzioni() {
        store.commit(StoreMutations.SetOpzioniVisibili, true);
    }
    get filtriApplicati(): boolean {
        let applicati = store.state.uiOrdiniMTM.filtri.nominativoCliente.length > 0 ||
            store.state.uiOrdiniMTM.filtri.numeroOrdine.length > 0 ||
            !!store.state.uiOrdiniMTM.filtri.dataConsegnaDa ||
            !!store.state.uiOrdiniMTM.filtri.dataConsegnaA ||
            !!store.state.uiOrdiniMTM.filtri.rigaDataChiusuraConsegnaA ||
            !!store.state.uiOrdiniMTM.filtri.rigaDataChiusuraConsegnaDa ||
            !!store.state.uiOrdiniMTM.filtri.rigaDataConsegnaFornitoreDa ||
            !!store.state.uiOrdiniMTM.filtri.rigaDataConsegnaFornitoreA ||
            store.state.uiOrdiniMTM.filtri.stato.length > 0;

        return applicati;
    }
}

